module.exports = __webpack_public_path__ + "static/img/cabinet12_1.59388722.gif";